import React from 'react';
import { List, Filter, TextInput, Datagrid, TextField, EmailField, EditButton, DeleteButton, Pagination, DateField } from 'react-admin';

const UserFilter = (props) => (
    <Filter {...props} autoComplete="off">
        <TextInput label="Search name" source="name" alwaysOn options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
        <TextInput label="Search e-mail" source="email"  />
        <TextInput label="Search phone" source="phoneNumber" />
    </Filter>
);

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500]} {...props} />;

export const UserList = (props) => (
    <List {...props} filters={<UserFilter />} title="Users" perPage={100} pagination={<PostPagination/>} sort={{ field: 'email', order: 'ASC' }}>
        <Datagrid>
            <TextField source="name" label="Name" />
            <EmailField source="email" label="Email" />
            <TextField source="phone_number" label="Phone" />
            <DateField source="updated_at" sortBy="updateDate" showTime locales="nl-NL"  />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);